import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=0f173ef5&scoped=true"
import script from "./Brands.vue?vue&type=script&lang=ts"
export * from "./Brands.vue?vue&type=script&lang=ts"
import style0 from "./Brands.vue?vue&type=style&index=0&id=0f173ef5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f173ef5",
  null
  
)

export default component.exports